/**
 * An user.
 *
 * @property {string} [company]
 * @property {boolean} [enabled]
 * @property {string} [email]
 * @property {number} [failedLogins]
 * @property {string} [lastLoginTime]
 * @property {string} [profileId]
 * @property {string} [realName
 * @property {UserStates} [state]
 * @property {string} [userId]
 * @property {string} [userInfo]
 * @property {string} [userName]
 * @property {string} [validFromDate]
 * @property {string} [validToDate]
 */
export class User {}
